import { ActionMap } from "../Config.store";

export interface DefaultJWTProps {
  accessToken?: string;
  expiresIn?: string;
}

export interface Identity {
  document?: string;
  username?: string;
  storeDocument?: string;
  login?: string;
}

export interface UserJWTProps {
  accessToken?: string;
  expiresIn?: string;
  idToken?: string;
  refreshToken?: string;
}

export type AccountTypeProps = "legalPerson" | "naturalPerson";

export type AuthStateProps = {
  hubJWT: DefaultJWTProps;
  userJWT: UserJWTProps & Identity;
  legalPersonJWT: DefaultJWTProps & Identity;
  accountType: AccountTypeProps;
};

export const AuthState: AuthStateProps = {
  hubJWT: {
    accessToken: "",
    expiresIn: "",
  },
  userJWT: {
    accessToken: "",
    expiresIn: "",
    idToken: "",
    refreshToken: "",
    username: "",
    document: "",
  },
  legalPersonJWT: {
    accessToken: "",
    expiresIn: "",
    username: "",
    document: "",
  },
  accountType: "naturalPerson",
};

export enum Types {
  setProposalToken = "SET_PROPOSAL_TOKEN",
  setHubToken = "SET_HUB_TOKEN",
  setUserTokens = "SET_USER_TOKENS",
  setLegalPersonToken = "SET_LEGAL_PERSON_TOKEN",
  cleanAuth = "CLEAN_AUTH",
  setTokens = "SET_TOKENS",
  setAccountType = "SET_ACCOUNT_TYPE",
}

export type AuthPayload = {
  [Types.setProposalToken]: {
    accessToken: string;
    expiresIn: string;
  };
  [Types.setHubToken]: {
    accessToken: string;
    expiresIn: string;
  };
  [Types.setUserTokens]: {
    accessToken: string;
    expiresIn: string;
    idToken: string;
    refreshToken: string;
  };
  [Types.setLegalPersonToken]: {
    accessToken: string;
    expiresIn: string;
    document: string;
    username: string;
  };
  [Types.setAccountType]: {
    accountType: AccountTypeProps;
  };
  [Types.setTokens]: {
    hubJWT?: DefaultJWTProps;
    userJWT?: UserJWTProps;
    legalPersonJWT?: DefaultJWTProps & Identity;
  };
  [Types.cleanAuth]: undefined;
};

export type AuthAction = ActionMap<AuthPayload>[keyof ActionMap<AuthPayload>];
